/* name event */
export const MESSAGE_PAGE_SEGMENT = "visitar-pagina"
export const EXPORT_TEMPLATE_DIVISION = "exportar-plantilla_divisiones"
export const EXPORT_EXIST_DIVISION = "exportar-existentes_divisiones"
export const IMPORT_DIVISIONS = "importar_divisiones"
export const IMPORT_FAILED_DIVISIONS = "importar-divisiones-error"
export const EXPORT_TEMPLATE_COLLABORATOR = "exportar-plantilla_colaboradores"
export const EXPORT_TEMPLATE_TEAMS = "exportar-plantilla_equipos"
export const IMPORT_COLLABORATOR = "importar_colaboradores"
export const IMPORT_FAILED_COLLABORATOR = "importar_colaboradores-error"
export const EXPORT_EXIST_COLLABORATOR = "exportar-existentes_colaboradores"
export const EDIT_COLLABORATOR = "editar_colaboradores"
export const EXPORT_TEMPLATE_CEASED_COLLABORATOR =
  "exportar-plantilla-cesados_colaboradores"
export const IMPORT_CEASED_COLLABORATOR = "importar-cesados_colaboradores"

export const EXPORT_TEMPLATE_SURVEY = "exportar-plantilla_cuestionario"
export const IMPORT_SURVEY = "importar_cuestionario"
export const EDIT_QUESTION_SURVEY = "editar-pregunta_cuestionario"
export const EDIT_SETTING_SURVEY = "editar-configuración_cuestionario"
export const EXPORT_SURVEY = "exportar_cuestionario"

export const CREATE_MEASURE = "crear_medicion"
export const STEP_FIRST_MEASURE = "configurar-correo_medicion"
export const EDIT_MAIL_MEASURE = "editar-correo_medicion"
export const STEP_SECOND_MEASURE = "seleccionar-destinatarios_medición"
export const EDIT_COLLABORATORS_MEASURE = "editar-destinatarios_medicion"
export const STEP_THIRD_MEASURE = "previsualizar_medicion"
export const SEND_TEST_MEASURE = "enviar-prueba_medicion"
export const STEP_FINAL_MEASURE = "agendar_medicion"
export const EDIT_TEST_MEASURE = "editar-agendado_medicion"
export const RESEND_MEASURE = "reenviar_medicion"
